const initialState = {
    //job order info 
    loadingFFQueryDetail: false,
    FFQueryDetailError: "",
    FFQueryDetail: {},
    //job order List 
    loadingFFAirExpJobOrderList: false,
    FFAirExpJobOrderListError: "",
    FFAirExpJobOrderList: [],

    //currency List 
    loadingFFAirExpCurrencyList: false,
    FFAirExpCurrencyListError: "",
    FFAirExpCurrencyList: [],

    //final Quotation
    loadingFFAirExpFinalQuotationList: false,
    FFAirExpFinalQuotationListError: "",
    FFAirExpFinalQuotationList: [],

    //currency List 
    loadingFFAirExpAirportList: false,
    FFAirExpAirportListError: "",
    FFAirExpAirportList: [],


    //organisation list
    loadingFFAirExpOrganisationList: false,
    FFAirExpOrganisationList: [],
    FFAirExpOrganisationListError: '',

    //organisation shipper branch list
    loadingFFAirExpShipperBranchList: false,
    FFAirExpShipperBranchList: [],
    FFAirExpShipperBranchListError: '',

    //organisation consignee branch list
    loadingFFAirExpConsigneeBranchList: false,
    FFAirExpConsigneeBranchList: [],
    FFAirExpConsigneeBranchListError: '',

    //organisatoin shipper branch bank list
    loadingFFAirExpShipperBranchBankList: false,
    FFAirExpShipperBranchBankList: [],
    FFAirExpShipperBranchBankListError: '',

    //organisatoin consignee branch bank list
    loadingFFAirExpConsigneeBranchBankList: false,
    FFAirExpConsigneeBranchBankList: [],
    FFAirExpConsigneeBranchBankListError: '',

    //hawb details
    loadingFFAirExpHAWBDetail: false,
    FFAirExpHAWBDetail: [],
    FFAirExpHAWBDetailError: '',

    //direct mawb details
    loadingFFAirExpDirectMAWBDetail: false,
    FFAirExpDirectMAWBDetail: [],
    FFAirExpDirectMAWBDetailError: '',

    //mawb details
    loadingFFAirExpMAWBDetail: false,
    FFAirExpMAWBDetail: [],
    FFAirExpMAWBDetailError: '',

    //unused hawb list
    loadingFFAirExpUnusedHAWBList: false,
    FFAirExpUnusedHAWBList: [],
    FFAirExpUnusedHAWBListError: '',

    //unused hawb update list
    loadingFFAirExpUnusedHAWBUpdateList: false,
    FFAirExpUnusedHAWBUpdateList: [],
    FFAirExpUnusedHAWBUpdateListError: '',


    //ff-> air-> exp -> console shipment list
    loadingFFAirExpConsoleShipmentList: false,
    FFAirExpConsoleShipmentList: [],
    FFAirExpConsoleShipmentListError: '',
    FFAirExpConsoleShipmentListCurrentPage: 0,
    FFAirExpConsoleShipmentListTotalPage: 0,
    FFAirExpConsoleShipmentListTotalData: 0,
    // FFAirExpConsoleShipmentListCount: {},

    //ff-> air-> exp -> mawb stock list
    loadingFFAirExpMAWBStockList: false,
    FFAirExpMAWBStockList: [],
    FFAirExpMAWBStockListError: '',
    FFAirExpMAWBStockListCurrentPage: 0,
    FFAirExpMAWBStockListTotalPage: 0,
    FFAirExpMAWBStockListTotalData: 0,
    // FFAirExpMAWBStockListCount: {},

    loadingFFAirExpMAWBStockDetail: true,
    FFAirExpMAWBStockDetail: null,
    FFAirExpMAWBStockDetailError: "",

    //ff-> air-> exp -> hawb stock list
    loadingFFAirExpHAWBStockList: false,
    FFAirExpHAWBStockList: [],
    FFAirExpHAWBStockListError: '',
    FFAirExpHAWBStockListCurrentPage: 0,
    FFAirExpHAWBStockListTotalPage: 0,
    FFAirExpHAWBStockListTotalData: 0,
    // FFAirExpHAWBStockListCount: {},

    loadingFFAirExpHAWBStockDetail: true,
    FFAirExpHAWBStockDetail: null,
    FFAirExpHAWBStockDetailError: "",

    loadingFFAirExpMAWBStocks: true,
    FFAirExpMAWBStocks: [],
    FFAirExpMAWBStocksError: '',

    loadingFFAirExpHAWBStocks: true,
    FFAirExpHAWBStocks: [],
    FFAirExpHAWBStocksError: '',

    //ff-> air-> exp -> direct shipment list
    loadingFFAirExpDirectShipmentList: false,
    FFAirExpDirectShipmentList: [],
    FFAirExpDirectShipmentListError: '',
    FFAirExpDirectShipmentListCurrentPage: 0,
    FFAirExpDirectShipmentListTotalPage: 0,
    FFAirExpDirectShipmentListTotalData: 0,
    // FFAirExpDirectShipmentListCount: {},

    //ff-> air-> exp -> console Manifest list
    loadingFFAirExpConsoleManifestList: false,
    FFAirExpConsoleManifestList: [],
    FFAirExpConsoleManifestListError: '',
    FFAirExpConsoleManifestListCurrentPage: 0,
    FFAirExpConsoleManifestListTotalPage: 0,
    FFAirExpConsoleManifestListTotalData: 0,
    // FFAirExpConsoleManifestListCount: {},

    //mawb => total freight calculation
    loadingFFAirExpTotalFreight: false,
    FFAirExpTotalFreight: {},
    FFAirExpTotalFreightError: '',

    loadingDirectMAWBData: false,
    DirectMAWBData: {},
    DirectMAWBDataError: '',

    loadingHAWBData: false,
    HAWBData: {},
    HAWBDataError: '',

    loadingConsoleMAWBData: false,
    ConsoleMAWBData: {},
    ConsoleMAWBDataError: '',

    loadingDimensionByQuotation: true,
    DimensionByQuotation: [],
    DimensionByQuotationError: '',

}

const FFAirExpReducer = (state = initialState, action) => {
    switch (action.type) {

        //query info List//
        case 'FIND_FF_QUERY_INFO_REQUEST':
            return {
                ...state,
                loadingFFQueryDetail: true,
                FFQueryDetail: {},
                FFQueryDetailError: '',
            };
        case 'FIND_FF_QUERY_INFO_SUCCESS':
            return {
                ...state,
                loadingFFQueryDetail: false,
                FFQueryDetail: action.payload,
            };
        case 'FIND_FF_QUERY_INFO_FAILURE':
            return {
                ...state,
                loadingFFQueryDetail: false,
                FFQueryDetailError: action.payload,
            };
        //query info List//

        //job order List//
        case 'FIND_FF_AIR_EXP_JOBORDER_REQUEST':
            return {
                ...state,
                loadingFFAirExpJobOrderList: true,
                FFAirExpJobOrderList: [],
                FFAirExpJobOrderListError: '',
            };
        case 'FIND_FF_AIR_EXP_JOBORDER_SUCCESS':
            return {
                ...state,
                loadingFFAirExpJobOrderList: false,
                FFAirExpJobOrderList: action.payload,
            };
        case 'FIND_FF_AIR_EXP_JOBORDER_FAILURE':
            return {
                ...state,
                loadingFFAirExpJobOrderList: false,
                FFAirExpJobOrderListError: action.payload,
            };
        //job order List//

        //currency List//
        case 'FIND_FF_AIR_EXP_CURRENCY_REQUEST':
            return {
                ...state,
                loadingFFAirExpCurrencyList: true,
                FFAirExpCurrencyList: [],
                FFAirExpCurrencyListError: '',
            };
        case 'FIND_FF_AIR_EXP_CURRENCY_SUCCESS':
            return {
                ...state,
                loadingFFAirExpCurrencyList: false,
                FFAirExpCurrencyList: action.payload,
            };
        case 'FIND_FF_AIR_EXP_CURRENCY_FAILURE':
            return {
                ...state,
                loadingFFAirExpCurrencyList: false,
                FFAirExpCurrencyListError: action.payload,
            };
        //currency List//

        //final Quotation List//
        case 'FIND_FF_AIR_EXP_FINAL_QUOTATION_REQUEST':
            return {
                ...state,
                loadingFFAirExpFinalQuotationList: true,
                FFAirExpFinalQuotationList: [],
                FFAirExpFinalQuotationListError: '',
            };
        case 'FIND_FF_AIR_EXP_FINAL_QUOTATION_SUCCESS':
            return {
                ...state,
                loadingFFAirExpFinalQuotationList: false,
                FFAirExpFinalQuotationList: action.payload,
            };
        case 'FIND_FF_AIR_EXP_FINAL_QUOTATION_FAILURE':
            return {
                ...state,
                loadingFFAirExpFinalQuotationList: false,
                FFAirExpFinalQuotationListError: action.payload,
            };
        //final Quotation List//

        //airport List//
        case 'FIND_FF_AIR_EXP_AIRPORT_REQUEST':
            return {
                ...state,
                loadingFFAirExpAirportList: true,
                FFAirExpAirportList: [],
                FFAirExpAirportListError: '',
            };
        case 'FIND_FF_AIR_EXP_AIRPORT_SUCCESS':
            return {
                ...state,
                loadingFFAirExpAirportList: false,
                FFAirExpAirportList: action.payload,
            };
        case 'FIND_FF_AIR_EXP_AIRPORT_FAILURE':
            return {
                ...state,
                loadingFFAirExpAirportList: false,
                FFAirExpAirportListError: action.payload,
            };
        //airport List//

        //hawb detail//
        case 'FIND_FF_AIR_EXP_HAWB_DETAIL_REQUEST':
            return {
                ...state,
                loadingFFAirExpHAWBDetail: true,
                FFAirExpHAWBDetail: [],
                FFAirExpHAWBDetailError: '',
            };
        case 'FIND_FF_AIR_EXP_HAWB_DETAIL_SUCCESS':
            return {
                ...state,
                loadingFFAirExpHAWBDetail: false,
                FFAirExpHAWBDetail: action.payload,
            };
        case 'FIND_FF_AIR_EXP_HAWB_DETAIL_FAILURE':
            return {
                ...state,
                loadingFFAirExpHAWBDetail: false,
                FFAirExpHAWBDetailError: action.payload,
            };
        //hawb detail//

        //direct mawb detail//
        case 'FIND_FF_AIR_EXP_DIRECT_MAWB_DETAIL_REQUEST':
            return {
                ...state,
                loadingFFAirExpDirectMAWBDetail: true,
                FFAirExpDirectMAWBDetail: [],
                FFAirExpDirectMAWBDetailError: '',
            };
        case 'FIND_FF_AIR_EXP_DIRECT_MAWB_DETAIL_SUCCESS':
            return {
                ...state,
                loadingFFAirExpDirectMAWBDetail: false,
                FFAirExpDirectMAWBDetail: action.payload,
            };
        case 'FIND_FF_AIR_EXP_DIRECT_MAWB_DETAIL_FAILURE':
            return {
                ...state,
                loadingFFAirExpDirectMAWBDetail: false,
                FFAirExpDirectMAWBDetailError: action.payload,
            };
        //direct mawb detail//

        //mawb detail//
        case 'FIND_FF_AIR_EXP_MAWB_DETAIL_REQUEST':
            return {
                ...state,
                loadingFFAirExpMAWBDetail: true,
                FFAirExpMAWBDetail: [],
                FFAirExpMAWBDetailError: '',
            };
        case 'FIND_FF_AIR_EXP_MAWB_DETAIL_SUCCESS':
            return {
                ...state,
                loadingFFAirExpMAWBDetail: false,
                FFAirExpMAWBDetail: action.payload,
            };
        case 'FIND_FF_AIR_EXP_MAWB_DETAIL_FAILURE':
            return {
                ...state,
                loadingFFAirExpMAWBDetail: false,
                FFAirExpMAWBDetailError: action.payload,
            };
        //mawb detail//

        //organisation List//
        case 'FIND_FF_AIR_EXP_ORGANISATION_REQUEST':
            return {
                ...state,
                loadingFFAirExpOrganisationList: true,
                FFAirExpOrganisationList: [],
                FFAirExpOrganisationListError: '',
            };
        case 'FIND_FF_AIR_EXP_ORGANISATION_SUCCESS':
            return {
                ...state,
                loadingFFAirExpOrganisationList: false,
                FFAirExpOrganisationList: action.payload,
            };
        case 'FIND_FF_AIR_EXP_ORGANISATION_FAILURE':
            return {
                ...state,
                loadingFFAirExpOrganisationList: false,
                FFAirExpOrganisationListError: action.payload,
            };
        //organisation List//

        //organisation shipper branch List//
        case 'FIND_FF_AIR_EXP_SHIPPER_BRANCH_REQUEST':
            return {
                ...state,
                loadingFFAirExpShipperBranchList: true,
                FFAirExpShipperBranchList: [],
                FFAirExpShipperBranchListError: '',
            };
        case 'FIND_FF_AIR_EXP_SHIPPER_BRANCH_SUCCESS':
            return {
                ...state,
                loadingFFAirExpShipperBranchList: false,
                FFAirExpShipperBranchList: action.payload,
            };
        case 'FIND_FF_AIR_EXP_SHIPPER_BRANCH_FAILURE':
            return {
                ...state,
                loadingFFAirExpShipperBranchList: false,
                FFAirExpShipperBranchListError: action.payload,
            };
        //organisation shipper branch List//

        //organisation consignee branch List//
        case 'FIND_FF_AIR_EXP_CONSIGNEE_BRANCH_REQUEST':
            return {
                ...state,
                loadingFFAirExpConsigneeBranchList: true,
                FFAirExpConsigneeBranchList: [],
                FFAirExpConsigneeBranchListError: '',
            };
        case 'FIND_FF_AIR_EXP_CONSIGNEE_BRANCH_SUCCESS':
            return {
                ...state,
                loadingFFAirExpConsigneeBranchList: false,
                FFAirExpConsigneeBranchList: action.payload,
            };
        case 'FIND_FF_AIR_EXP_CONSIGNEE_BRANCH_FAILURE':
            return {
                ...state,
                loadingFFAirExpConsigneeBranchList: false,
                FFAirExpConsigneeBranchListError: action.payload,
            };
        //organisation consignee branch List//

        //organisation shipper branch bank List//
        case 'FIND_FF_AIR_EXP_SHIPPER_BRANCH_BANK_REQUEST':
            return {
                ...state,
                loadingFFAirExpShipperBranchBankList: true,
                FFAirExpShipperBranchBankList: [],
                FFAirExpShipperBranchBankListError: '',
            };
        case 'FIND_FF_AIR_EXP_SHIPPER_BRANCH_BANK_SUCCESS':
            return {
                ...state,
                loadingFFAirExpShipperBranchBankList: false,
                FFAirExpShipperBranchBankList: action.payload,
            };
        case 'FIND_FF_AIR_EXP_SHIPPER_BRANCH_BANK_FAILURE':
            return {
                ...state,
                loadingFFAirExpShipperBranchBankList: false,
                FFAirExpShipperBranchBankListError: action.payload,
            };
        //organisation shipper branch bank List//

        //organisation consignee branch bank List//
        case 'FIND_FF_AIR_EXP_CONSIGNEE_BRANCH_BANK_REQUEST':
            return {
                ...state,
                loadingFFAirExpConsigneeBranchBankList: true,
                FFAirExpConsigneeBranchBankList: [],
                FFAirExpConsigneeBranchBankListError: '',
            };
        case 'FIND_FF_AIR_EXP_CONSIGNEE_BRANCH_BANK_SUCCESS':
            return {
                ...state,
                loadingFFAirExpConsigneeBranchBankList: false,
                FFAirExpConsigneeBranchBankList: action.payload,
            };
        case 'FIND_FF_AIR_EXP_CONSIGNEE_BRANCH_BANK_FAILURE':
            return {
                ...state,
                loadingFFAirExpConsigneeBranchBankList: false,
                FFAirExpConsigneeBranchBankListError: action.payload,
            };
        //organisation consignee branch bank List//

        //mawb-> unused hawb list//
        case 'FIND_FF_AIR_EXP_UNUSED_HAWB_REQUEST':
            return {
                ...state,
                loadingFFAirExpUnusedHAWBList: true,
                FFAirExpUnusedHAWBList: [],
                FFAirExpUnusedHAWBListError: '',
            };
        case 'FIND_FF_AIR_EXP_UNUSED_HAWB_SUCCESS':
            return {
                ...state,
                loadingFFAirExpUnusedHAWBList: false,
                FFAirExpUnusedHAWBList: action.payload,
            };
        case 'FIND_FF_AIR_EXP_UNUSED_HAWB_FAILURE':
            return {
                ...state,
                loadingFFAirExpUnusedHAWBList: false,
                FFAirExpUnusedHAWBListError: action.payload,
            };
        //mawb-> unused hawb list//

        //mawb-> unused hawb update list//
        case 'FIND_FF_AIR_EXP_UNUSED_HAWB_UPDATE_REQUEST':
            return {
                ...state,
                loadingFFAirExpUnusedHAWBUpdateList: true,
                FFAirExpUnusedHAWBUpdateList: [],
                FFAirExpUnusedHAWBUpdateListError: '',
            };
        case 'FIND_FF_AIR_EXP_UNUSED_HAWB_UPDATE_SUCCESS':
            return {
                ...state,
                loadingFFAirExpUnusedHAWBUpdateList: false,
                FFAirExpUnusedHAWBUpdateList: action.payload,
            };
        case 'FIND_FF_AIR_EXP_UNUSED_HAWB_UPDATE_FAILURE':
            return {
                ...state,
                loadingFFAirExpUnusedHAWBUpdateList: false,
                FFAirExpUnusedHAWBUpdateListError: action.payload,
            };
        //mawb-> unused hawb update list//

        //mawb-> unused mawb in console manifest add form//
        case 'FIND_FF_AIR_EXP_CONSOLE_MANIFEST_MAWB_ADD_LIST_REQUEST':
            return {
                ...state,
                loadingFFAirExpUnusedConsoleManifestMAWBAddList: true,
                FFAirExpUnusedConsoleManifestMAWBAddList: [],
                FFAirExpUnusedConsoleManifestMAWBAddListError: '',
            };
        case 'FIND_FF_AIR_EXP_CONSOLE_MANIFEST_MAWB_ADD_LIST_SUCCESS':
            return {
                ...state,
                loadingFFAirExpUnusedConsoleManifestMAWBAddList: false,
                FFAirExpUnusedConsoleManifestMAWBAddList: action.payload,
            };
        case 'FIND_FF_AIR_EXP_CONSOLE_MANIFEST_MAWB_ADD_LIST_FAILURE':
            return {
                ...state,
                loadingFFAirExpUnusedConsoleManifestMAWBAddList: false,
                FFAirExpUnusedConsoleManifestMAWBAddListError: action.payload,
            };
        //mawb-> unused mawb in console manifest add form//

        //mawb-> calculate total freight//
        case 'FIND_CALCULATE_TOTAL_FREIGHT_REQUEST':
            return {
                ...state,
                loadingFFAirExpTotalFreight: true,
                FFAirExpTotalFreight: {},
                FFAirExpTotalFreightError: '',
            };
        case 'FIND_CALCULATE_TOTAL_FREIGHT_SUCCESS':
            return {
                ...state,
                loadingFFAirExpTotalFreight: false,
                FFAirExpTotalFreight: action.payload,
            };
        case 'FIND_CALCULATE_TOTAL_FREIGHT_FAILURE':
            return {
                ...state,
                loadingFFAirExpTotalFreight: false,
                FFAirExpTotalFreightError: action.payload,
            };
        //mawb-> calculate total freight//

        //ff -> air -> exp -> console shipment list//
        case 'FIND_FF_AIR_EXP_CONSOLE_SHIPMENT_LIST_REQUEST':
            return {
                ...state,
                loadingFFAirExpConsoleShipmentList: true,
                FFAirExpConsoleShipmentList: [],
                FFAirExpConsoleShipmentListError: '',
                FFAirExpConsoleShipmentListCurrentPage: 0,
                FFAirExpConsoleShipmentListTotalPage: 0,
                FFAirExpConsoleShipmentListTotalData: 0,
                // FFAirExpConsoleShipmentListCount: {},
            };
        case 'FIND_FF_AIR_EXP_CONSOLE_SHIPMENT_LIST_SUCCESS':
            return {
                ...state,
                loadingFFAirExpConsoleShipmentList: false,
                FFAirExpConsoleShipmentList: action.payload.data,
                FFAirExpConsoleShipmentListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                FFAirExpConsoleShipmentListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                FFAirExpConsoleShipmentListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
                // FFAirExpConsoleShipmentListCount: {},
            };
        case 'FIND_FF_AIR_EXP_CONSOLE_SHIPMENT_LIST_FAILURE':
            return {
                ...state,
                loadingFFAirExpConsoleShipmentList: true,
                FFAirExpConsoleShipmentListError: '',
                FFAirExpConsoleShipmentListCurrentPage: 1,
                FFAirExpConsoleShipmentListTotalPage: 0,
                FFAirExpConsoleShipmentListTotalData: 0,
                // FFAirExpConsoleShipmentListCount: {},
            };
        //ff -> air -> exp -> console shipment list//

        //ff -> air -> exp -> direct shipment list//
        case 'FIND_FF_AIR_EXP_DIRECT_SHIPMENT_LIST_REQUEST':
            return {
                ...state,
                loadingFFAirExpDirectShipmentList: true,
                FFAirExpDirectShipmentList: [],
                FFAirExpDirectShipmentListError: '',
                FFAirExpDirectShipmentListCurrentPage: 0,
                FFAirExpDirectShipmentListTotalPage: 0,
                FFAirExpDirectShipmentListTotalData: 0,
                // FFAirExpDirectShipmentListCount: {},
            };
        case 'FIND_FF_AIR_EXP_DIRECT_SHIPMENT_LIST_SUCCESS':
            return {
                ...state,
                loadingFFAirExpDirectShipmentList: false,
                FFAirExpDirectShipmentList: action.payload.data,
                FFAirExpDirectShipmentListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                FFAirExpDirectShipmentListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                FFAirExpDirectShipmentListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
                // FFAirExpDirectShipmentListCount: {},
            };
        case 'FIND_FF_AIR_EXP_DIRECT_SHIPMENT_LIST_FAILURE':
            return {
                ...state,
                loadingFFAirExpDirectShipmentList: true,
                FFAirExpDirectShipmentListError: '',
                FFAirExpDirectShipmentListCurrentPage: 1,
                FFAirExpDirectShipmentListTotalPage: 0,
                FFAirExpDirectShipmentListTotalData: 0,
                // FFAirExpDirectShipmentListCount: {},
            };
        //ff -> air -> exp -> direct shipment list//

        //ff -> air -> exp -> mawb stock list//
        case 'FIND_FF_AIR_EXP_MAWB_STOCK_LIST_REQUEST':
            return {
                ...state,
                loadingFFAirExpMAWBStockList: true,
                FFAirExpMAWBStockList: [],
                FFAirExpMAWBStockListError: '',
                FFAirExpMAWBStockListCurrentPage: 0,
                FFAirExpMAWBStockListTotalPage: 0,
                FFAirExpMAWBStockListTotalData: 0,
                // FFAirExpMAWBStockListCount: {},
            };
        case 'FIND_FF_AIR_EXP_MAWB_STOCK_LIST_SUCCESS':
            return {
                ...state,
                loadingFFAirExpMAWBStockList: false,
                FFAirExpMAWBStockList: action.payload.data,
                FFAirExpMAWBStockListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                FFAirExpMAWBStockListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                FFAirExpMAWBStockListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
                // FFAirExpMAWBStockListCount: {},
            };
        case 'FIND_FF_AIR_EXP_MAWB_STOCK_LIST_FAILURE':
            return {
                ...state,
                loadingFFAirExpMAWBStockList: true,
                FFAirExpMAWBStockListError: '',
                FFAirExpMAWBStockListCurrentPage: 1,
                FFAirExpMAWBStockListTotalPage: 0,
                FFAirExpMAWBStockListTotalData: 0,
                // FFAirExpMAWBStockListCount: {},
            };
        //ff -> air -> exp -> mawb stock list//

        //ff -> air -> exp -> mawb stock detail//
        case 'FIND_FF_AIR_EXP_MAWB_STOCK_DETAIL_REQUEST':
            return {
                ...state,
                loadingFFAirExpMAWBStockDetail: true,
                FFAirExpMAWBStockDetail: null,
                FFAirExpMAWBStockDetailError: '',
            };
        case 'FIND_FF_AIR_EXP_MAWB_STOCK_DETAIL_SUCCESS':
            return {
                ...state,
                loadingFFAirExpMAWBStockDetail: false,
                FFAirExpMAWBStockDetail: action.payload,
            };
        case 'FIND_FF_AIR_EXP_MAWB_STOCK_DETAIL_FAILURE':
            return {
                ...state,
                loadingFFAirExpMAWBStockDetail: true,
                FFAirExpMAWBStockDetailError: action.payload,
            };
        //ff -> air -> exp -> mawb stock detail//

        //ff -> air -> exp -> mawb stock for dropdown//
        case 'FIND_FF_AIR_EXP_MAWB_STOCKS_REQUEST':
            return {
                ...state,
                loadingFFAirExpMAWBStocks: true,
                FFAirExpMAWBStocks: [],
                FFAirExpMAWBStocksError: '',
            };
        case 'FIND_FF_AIR_EXP_MAWB_STOCKS_SUCCESS':
            return {
                ...state,
                loadingFFAirExpMAWBStocks: false,
                FFAirExpMAWBStocks: action.payload,
            };
        case 'FIND_FF_AIR_EXP_MAWB_STOCKS_FAILURE':
            return {
                ...state,
                loadingFFAirExpMAWBStocks: true,
                FFAirExpMAWBStocksError: action.payload,
            };
        //ff -> air -> exp -> mawb stock for dropdown//

        //ff -> air -> exp -> hawb stock for dropdown//
        case 'FIND_FF_AIR_EXP_HAWB_STOCKS_REQUEST':
            return {
                ...state,
                loadingFFAirExpHAWBStocks: true,
                FFAirExpHAWBStocks: [],
                FFAirExpHAWBStocksError: '',
            };
        case 'FIND_FF_AIR_EXP_HAWB_STOCKS_SUCCESS':
            return {
                ...state,
                loadingFFAirExpHAWBStocks: false,
                FFAirExpHAWBStocks: action.payload,
            };
        case 'FIND_FF_AIR_EXP_HAWB_STOCKS_FAILURE':
            return {
                ...state,
                loadingFFAirExpHAWBStocks: true,
                FFAirExpHAWBStocksError: action.payload,
            };
        //ff -> air -> exp -> hawb stock for dropdown//

        //ff -> air -> exp -> hawb stock list//
        case 'FIND_FF_AIR_EXP_HAWB_STOCK_LIST_REQUEST':
            return {
                ...state,
                loadingFFAirExpHAWBStockList: true,
                FFAirExpHAWBStockList: [],
                FFAirExpHAWBStockListError: '',
                FFAirExpHAWBStockListCurrentPage: 0,
                FFAirExpHAWBStockListTotalPage: 0,
                FFAirExpHAWBStockListTotalData: 0,
                // FFAirExpHAWBStockListCount: {},
            };
        case 'FIND_FF_AIR_EXP_HAWB_STOCK_LIST_SUCCESS':
            return {
                ...state,
                loadingFFAirExpHAWBStockList: false,
                FFAirExpHAWBStockList: action.payload.data,
                FFAirExpHAWBStockListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                FFAirExpHAWBStockListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                FFAirExpHAWBStockListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
                // FFAirExpHAWBStockListCount: {},
            };
        case 'FIND_FF_AIR_EXP_HAWB_STOCK_LIST_FAILURE':
            return {
                ...state,
                loadingFFAirExpHAWBStockList: true,
                FFAirExpHAWBStockListError: '',
                FFAirExpHAWBStockListCurrentPage: 1,
                FFAirExpHAWBStockListTotalPage: 0,
                FFAirExpHAWBStockListTotalData: 0,
                // FFAirExpHAWBStockListCount: {},
            };
        //ff -> air -> exp -> hawb stock list//

        //ff -> air -> exp -> hawb stock detail//
        case 'FIND_FF_AIR_EXP_HAWB_STOCK_DETAIL_REQUEST':
            return {
                ...state,
                loadingFFAirExpHAWBStockDetail: true,
                FFAirExpHAWBStockDetail: null,
                FFAirExpHAWBStockDetailError: '',
            };
        case 'FIND_FF_AIR_EXP_HAWB_STOCK_DETAIL_SUCCESS':
            return {
                ...state,
                loadingFFAirExpHAWBStockDetail: false,
                FFAirExpHAWBStockDetail: action.payload,
            };
        case 'FIND_FF_AIR_EXP_HAWB_STOCK_DETAIL_FAILURE':
            return {
                ...state,
                loadingFFAirExpHAWBStockDetail: true,
                FFAirExpHAWBStockDetailError: action.payload,
            };
        //ff -> air -> exp -> hawb stock detail//

        //ff -> air -> exp -> console manifest list//
        case 'FIND_FF_AIR_EXP_CONSOLE_MANIFEST_LIST_REQUEST':
            return {
                ...state,
                loadingFFAirExpConsoleManifestList: true,
                FFAirExpConsoleManifestList: [],
                FFAirExpConsoleManifestListError: '',
                FFAirExpConsoleManifestListCurrentPage: 0,
                FFAirExpConsoleManifestListTotalPage: 0,
                FFAirExpConsoleManifestListTotalData: 0,
                // FFAirExpConsoleManifestListCount: {},
            };
        case 'FIND_FF_AIR_EXP_CONSOLE_MANIFEST_LIST_SUCCESS':
            return {
                ...state,
                loadingFFAirExpConsoleManifestList: false,
                FFAirExpConsoleManifestList: action.payload.data,
                FFAirExpConsoleManifestListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                FFAirExpConsoleManifestListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                FFAirExpConsoleManifestListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
                // FFAirExpConsoleManifestListCount: {},
            };
        case 'FIND_FF_AIR_EXP_CONSOLE_MANIFEST_LIST_FAILURE':
            return {
                ...state,
                loadingFFAirExpConsoleManifestList: true,
                FFAirExpConsoleManifestListError: '',
                FFAirExpConsoleManifestListCurrentPage: 1,
                FFAirExpConsoleManifestListTotalPage: 0,
                FFAirExpConsoleManifestListTotalData: 0,
                // FFAirExpConsoleManifestListCount: {},
            };
        //ff -> air -> exp -> console manifest list//

        case 'GET_DIRECT_MAWB_DATA_REQUEST':
            return {
                ...state,
                loadingDirectMAWBData: true,
                DirectMAWBData: null,
                DirectMAWBDataError: '',
            };
        case 'GET_DIRECT_MAWB_DATA_SUCCESS':
            return {
                ...state,
                loadingDirectMAWBData: false,
                DirectMAWBData: action.payload,
            };
        case 'GET_DIRECT_MAWB_DATA_FAILURE':
            return {
                ...state,
                loadingDirectMAWBData: true,
                DirectMAWBDataError: action.payload,
            };

        case 'GET_HAWB_DATA_REQUEST':
            return {
                ...state,
                loadingHAWBData: true,
                HAWBData: null,
                HAWBDataError: '',
            };
        case 'GET_HAWB_DATA_SUCCESS':
            return {
                ...state,
                loadingHAWBData: false,
                HAWBData: action.payload,
            };
        case 'GET_HAWB_DATA_FAILURE':
            return {
                ...state,
                loadingHAWBData: true,
                HAWBDataError: action.payload,
            };


        case 'GET_CONSOLE_MAWB_DATA_REQUEST':
            return {
                ...state,
                loadingConsoleMAWBData: true,
                ConsoleMAWBData: null,
                ConsoleMAWBDataError: '',
            };
        case 'GET_CONSOLE_MAWB_DATA_SUCCESS':
            return {
                ...state,
                loadingConsoleMAWBData: false,
                ConsoleMAWBData: action.payload,
            };
        case 'GET_CONSOLE_MAWB_DATA_FAILURE':
            return {
                ...state,
                loadingConsoleMAWBData: true,
                ConsoleMAWBDataError: action.payload,
            };

        case 'GET_DIMENSION_BY_QUOTATION_REQUEST':
            return {
                ...state,
                loadingDimensionByQuotation: true,
                DimensionByQuotation: [],
                DimensionByQuotationError: '',
            };
        case 'GET_DIMENSION_BY_QUOTATION_SUCCESS':
            return {
                ...state,
                loadingDimensionByQuotation: false,
                DimensionByQuotation: action.payload,
            };
        case 'GET_DIMENSION_BY_QUOTATION_FAILURE':
            return {
                ...state,
                loadingDimensionByQuotation: true,
                DimensionByQuotationError: action.payload,
            };

        default:
            return state;
    }
}

export default FFAirExpReducer;